import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { StoxlyClient } from '@stoxly/api-client';

/**
 * Fox F5 — the Overview page's two computed strips. Both are per-symbol reads with no
 * query params, so they key on the symbol alone.
 */
export function createResearchOverviewQueries(client: StoxlyClient) {
  return createQueryKeys('researchOverview', {
    // ['researchOverview', 'dailySignals', symbol] — insider 30d net flow + rating digest.
    dailySignals: (symbol: string) => ({
      queryKey: [symbol],
      queryFn: ({ signal }) =>
        client.researchOverviewGetDailySignals({ params: { symbol }, signal }),
    }),

    // ['researchOverview', 'priceStats', symbol] — beta, volatility, 52w band, 1y change.
    priceStats: (symbol: string) => ({
      queryKey: [symbol],
      queryFn: ({ signal }) => client.researchOverviewGetPriceStats({ params: { symbol }, signal }),
    }),
  });
}
